import $ from 'jquery';
import { WindowExtended } from '../types';

$.support.cors = true;

declare const window: WindowExtended & {
  external: External & {
    CallIntegration: any;
  };
};

export function SendCommand(action: string, url: string, numberToDial: string) {
  if (
    typeof window.external !== 'undefined' &&
    typeof window.external.CallIntegration !== 'undefined'
  ) {
    window.external.CallIntegration(action, numberToDial);
  } else {
    $.getJSON(
      url,
      {
        Action: action,
        ContextID: '1234567890',
        TargetNumber: numberToDial,
      },
      function(data: any) {
        CheckResult(data);
      }
    ).fail(function() {
      CheckResult(null);
    });
  }
}

function CheckResult(ResultObj: any) {
  if (ResultObj) {
    if (ResultObj.Result === 'Success') {
      return;
    } else {
      console.log(ResultObj.Result);
    }
  } else {
    console.log('Failed to get a valid response from the Integration Server');
  }
}
